"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-martino-in-passiria": {
    "f132bb38": [{
      "hkey": "80b3e903",
      "slug": "san-martino-in-passiria",
      "name": "San Martino in Passiria",
      "primary": true,
      "skipSearch": false
    }],
    "cresta": [{
      "hkey": "80b3e903",
      "slug": "san-martino-in-passiria",
      "name": "San Martino in Passiria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a65f06bc": [{
      "hkey": "80b3e903",
      "slug": "san-martino-in-passiria",
      "name": "San Martino in Passiria",
      "primary": true,
      "skipSearch": false
    }],
    "montaccio": [{
      "hkey": "80b3e903",
      "slug": "san-martino-in-passiria",
      "name": "San Martino in Passiria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a335331e": [{
      "hkey": "80b3e903",
      "slug": "san-martino-in-passiria",
      "name": "San Martino in Passiria",
      "primary": true,
      "skipSearch": false
    }],
    "novale": [{
      "hkey": "80b3e903",
      "slug": "san-martino-in-passiria",
      "name": "San Martino in Passiria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ef379c85": [{
      "hkey": "80b3e903",
      "slug": "san-martino-in-passiria",
      "name": "San Martino in Passiria",
      "primary": true,
      "skipSearch": false
    }],
    "vallone": [{
      "hkey": "80b3e903",
      "slug": "san-martino-in-passiria",
      "name": "San Martino in Passiria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;